import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function levelToColor(level) {
  return level === "warning"
    ? "text-orange-600"
    : level === "info"
      ? "text-blue-600"
      : level === "incomplete"
        ? "text-yellow-600"
        : "text-red-600";
}

export function levelToIconName(level) {
  return level === "warning"
    ? "triangle-exclamation"
    : level === "info"
      ? "circle-info"
      : level === "incomplete"
        ? "clock"
        :"circle-exclamation";
}

export default function ProblemIndicator({ level, message }) {
  return (
    <div className={`text-sm flex gap-0.5 items-center pl-0.5 ${levelToColor(level)}`}>
      <FontAwesomeIcon icon={levelToIconName(level)} />
      {message}
    </div>
  );
}
